import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
} from "react-native";
import store from "app/redux/store";
import Text from "app/components/Text";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
// import Canvas from 'app/components/Canvas'
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import iconHelpers from "app/utils/iconHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

// import {Sigma, RandomizeNodePositions, RelativeSize, EdgeShapes, NodeShapes, NOverlap, } from 'react-sigma';
import Graph from "react-graph-vis";
import "vis-network/dist/dist/vis-network.css";

import Hoverable from "app/components/Hoverable";
import HoverableTooltip from "app/components/HoverableTooltip";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

const WEB = Platform.OS == "web";
const REVERSE = false;
const CONSTELATE = true;

import { StyleContext } from "app/contexts/Style";

export default class Network extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);

    // Get root_id from route params if provided
    let { route } = this.props;
    let rootId = route?.params?.root_id || "root";

    this.state = {
      values: [],
      fetching: false,
      query: "",
      hideComplete: true,
      fromBottom: true,
      showOnlyStarred: false,
      showHidden: 0,
      showNotes: true,
      showSnoozed: 0,
      showDoneToday: 1,
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
      showDuplicates: false,
      sizeByDescendants: false,
      physicsEnabled: true,
      hierarchicalLayout: false,
      scrollHeight: Dimensions.get("window").height,
      hiddenIds: [],
      rootId: rootId, // Store the root ID
      rootValue: null, // Will store the root value data
    };
  }

  async componentDidMount() {
    // let values = await storageActions.fetchItem("values");
    let values = [];
    if (!!values?.length) {
      // values = valueHelpers.sortByTimeline(values)
      // values = valueHelpers.applyLevels(values);
      // values = textHelpers.oldestFirst(values, "id");
      // values = valueHelpers.applyColors(values);
      console.log("local vals", values);
      this.setState({ values });
    } else {
      this.fetch();
    }
    // this._unsubscribe = this.props.navigation.addListener("focus", () => {
    //   this.fetch();
    // });
    if (WEB && !!this.filterInput) this.filterInput.focus();
    // this.fetch()
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  fetch = async () => {
    this.setState({ fetching: true });

    let { rootId } = this.state;

    console.log(`Fetching family for rootId: ${rootId}`);

    // Fetch family data for the specified root (could be "root" or a value ID)
    let res = await valueActions.getFamily(rootId, { down: 2 });
    let values = res?.values;
    console.log(`FAMILY VALUES! Got ${values?.length || 0} values:`, values);

    let { preferences } = store.getState();

    // If we have a custom root (not "root"), find the root value
    let rootValue = null;
    if (rootId !== "root" && values) {
      rootValue = values.find(v => v.id == rootId);
      console.log(`Found rootValue:`, rootValue);
    }

    console.log(`Setting state with ${values?.length || 0} values`);
    this.setState({
      values: values || [],
      rootValue,
      hiddenIds: preferences?.hiddenIds || [],
      fetching: false,
    });
  };

  other_fetch = async () => {
    let data = {};
    if (this.state.fetchOption == "top") {
      data.top = true;
    }

    let allValues = await valueActions.index();

    let { preferences } = store.getState();

    // Filter out hidden values
    if (allValues && preferences?.hiddenIds) {
      allValues = allValues.filter(
        (v) => !preferences.hiddenIds.includes(v?.id),
      );
    }

    this.setState({
      values: allValues || [],
      hiddenIds: preferences?.hiddenIds || [],
      fetching: false,
    });
  };

  old_fetch = async () => {
    this.setState({ fetching: true });
    console.log("network view fetch...");
    let timestamp = Date.now();
    let values = await valueActions.index([], { include_levels: true });
    let duration = (Date.now() - timestamp) / 1000;
    console.log(`fetch completed in ${duration.toFixed(2)} seconds`, values);
    if (!!values) {
      // values = valueHelpers.sortByTimeline(values);
      // values = valueHelpers.applyLevels(values);
      values = textHelpers.oldestFirst(values, "id");
      // values = valueHelpers.applyColors(values);
      let hiddenIds = await storageActions.fetchItem("hiddenIds");
      this.setState({ values, hiddenIds, fetching: false });
      storageActions.saveItem("values", values);
    } else console.warn("error", values);
  };

  render() {
    let { navigation } = this.props;
    let {
      values,
      fetching,
      query,
      hideComplete,
      showSnoozed,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      fromBottom,
      familyIds,
      selectedValue,
      lines,
      quickActionsId,
      enableBlur,
      redrawKey,
      showDuplicates,
      sizeByDescendants,
      physicsEnabled,
      hierarchicalLayout,
      scrollHeight,
      showHidden,
    } = this.state;

    let buttonColorOptions = [
      this.context.colors.trim,
      this.context.colors.active,
      this.context.colors.activeHighlight,
    ];

    return (
      <View style={this.styles().container} key={redrawKey}>
        <StatusBar style="auto" />
        <View style={[this.styles().row, this.styles().queryRow]}>
          <TouchableOpacity
            onPress={this.fetch}
            style={[
              this.styles().icon,
              { marginRight: this.context.sizes.base },
            ]}
            disabled={fetching}
          >
            {fetching ? (
              <ActivityIndicator
                size="small"
                color={this.context.colors.active}
              />
            ) : (
              <Ionicons
                name="refresh"
                size={this.context.sizes.itemHeight}
                color={this.context.colors.active}
              />
            )}
          </TouchableOpacity>
          <TextInput
            ref={(c) => (this.filterInput = c)}
            onKeyPress={this.handleKeyPress}
            style={this.styles().input}
            placeholderTextColor={this.context.colors.placeholder}
            value={query}
            placeholder={"filter"}
            onChangeText={(query) => this.setState({ query })}
          />
          <HoverableTooltip
            text={hideComplete ? "Completed values hidden" : "Showing completed values"}
          >
            <TouchableOpacity
              onPress={() => this.setState({ hideComplete: !hideComplete })}
              style={this.styles().icon}
            >
              <Feather
                name={"check-circle"}
                size={this.context.sizes.itemHeight}
                color={
                  hideComplete
                    ? this.context.colors.trim
                    : this.context.colors.active
                }
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={fromBottom ? "Tree levels from bottom" : "Tree levels from top"}
          >
            <TouchableOpacity
              onPress={() => this.setState({ fromBottom: !fromBottom })}
              style={{ marginLeft: this.context.sizes.base }}
            >
              <Entypo
                name="flow-tree"
                size={this.context.sizes.itemHeight}
                color={
                  fromBottom
                    ? this.context.colors.trim
                    : this.context.colors.active
                }
                style={fromBottom ? null : { transform: [{ rotateZ: "180deg" }] }}
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={
              showSnoozed === 0
                ? "Snoozed values hidden"
                : showSnoozed === 1
                ? "Showing all values"
                : "Showing only snoozed values"
            }
          >
            <TouchableOpacity
              onPress={() =>
                this.setState({
                  showSnoozed: showSnoozed >= 2 ? 0 : showSnoozed + 1,
                })
              }
              style={{ marginLeft: this.context.sizes.base }}
            >
              <FontAwesome
                name="moon-o"
                size={this.context.sizes.itemHeight}
                color={buttonColorOptions[showSnoozed]}
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={
              showDuplicates
                ? "Showing duplicates: values can appear multiple times in different branches"
                : "Duplicates hidden: each value appears once, connected to all parents"
            }
          >
            <TouchableOpacity
              onPress={() => this.setState({ showDuplicates: !showDuplicates })}
              style={this.styles().icon}
            >
              <MaterialCommunityIcons
                name="content-duplicate"
                size={this.context.sizes.itemHeight}
                color={
                  showDuplicates
                    ? this.context.colors.active
                    : this.context.colors.trim
                }
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={
              sizeByDescendants
                ? "Node size based on total descendant count"
                : "Node size based on level (depth)"
            }
          >
            <TouchableOpacity
              onPress={() => this.setState({ sizeByDescendants: !sizeByDescendants })}
              style={this.styles().icon}
            >
              <MaterialCommunityIcons
                name="family-tree"
                size={this.context.sizes.itemHeight}
                color={
                  sizeByDescendants
                    ? this.context.colors.active
                    : this.context.colors.trim
                }
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={
              physicsEnabled
                ? "Physics enabled: nodes move dynamically"
                : "Physics disabled: static layout"
            }
          >
            <TouchableOpacity
              onPress={() => this.setState({ physicsEnabled: !physicsEnabled })}
              style={this.styles().icon}
            >
              <MaterialCommunityIcons
                name={physicsEnabled ? "orbit" : "orbit-variant"}
                size={this.context.sizes.itemHeight}
                color={
                  physicsEnabled
                    ? this.context.colors.active
                    : this.context.colors.trim
                }
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={
              hierarchicalLayout
                ? "Hierarchical layout: organized tree structure"
                : "Free-form layout: physics-based positioning"
            }
          >
            <TouchableOpacity
              onPress={() => this.setState({ hierarchicalLayout: !hierarchicalLayout })}
              style={this.styles().icon}
            >
              <MaterialCommunityIcons
                name="file-tree"
                size={this.context.sizes.itemHeight}
                color={
                  hierarchicalLayout
                    ? this.context.colors.active
                    : this.context.colors.trim
                }
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip text="Redraw network graph">
            <TouchableOpacity
              onPress={() => this.setState({ redrawKey: redrawKey + 1 })}
              style={this.styles().icon}
            >
              <Text style={{ color: this.context.colors.trim }}>RE</Text>
            </TouchableOpacity>
          </HoverableTooltip>
          {/*<TouchableOpacity onPress={() => this.setState({showOnlyStarred: !showOnlyStarred})} style={this.styles().icon}>
            <Ionicons name={`ios-star${showOnlyStarred ? '' : '-outline'}`} size={this.context.sizes.itemHeight} color={showOnlyStarred ? this.context.colors.active : this.context.colors.trim} />
          </TouchableOpacity>*/}
          {/*<TouchableOpacity onPress={() => this.setState({showNotes: !showNotes})} style={this.styles().icon}>
            <Octicons name={`note`} size={this.context.sizes.itemHeight} color={showNotes ? this.context.colors.active : this.context.colors.trim} />
          </TouchableOpacity>*/}
          <HoverableTooltip
            text={enableBlur ? "Blur effect enabled" : "Blur effect disabled"}
          >
            <TouchableOpacity
              onPress={() => this.setState({ enableBlur: !enableBlur })}
              style={this.styles().icon}
            >
              <FontAwesome
                name={"search"}
                size={this.context.sizes.itemHeight - 4}
                color={
                  enableBlur
                    ? this.context.colors.trim
                    : this.context.colors.active
                }
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={
              showDoneToday === 0
                ? "Values done today hidden"
                : showDoneToday === 1
                ? "Showing all values"
                : "Showing only values done today (with ancestors)"
            }
          >
            <TouchableOpacity
              onPress={() =>
                this.setState({
                  showDoneToday: showDoneToday >= 2 ? 0 : showDoneToday + 1,
                })
              }
              style={this.styles().icon}
            >
              <FontAwesome
                name={"calendar-check-o"}
                size={this.context.sizes.itemHeight - 4}
                color={buttonColorOptions[showDoneToday]}
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip
            text={
              showHidden === 0
                ? "Hidden values not shown"
                : showHidden === 1
                ? "Showing all values"
                : "Showing only hidden values"
            }
          >
            <TouchableOpacity
              onPress={() =>
                this.setState({
                  showHidden: showHidden >= 2 ? 0 : showHidden + 1,
                })
              }
              style={this.styles().icon}
            >
              <Ionicons
                name="eye-off"
                size={this.context.sizes.itemHeight - 4}
                color={buttonColorOptions[showHidden]}
              />
            </TouchableOpacity>
          </HoverableTooltip>
          <HoverableTooltip text="Create new value">
            <TouchableOpacity
              onPress={() => navigation.navigate("Create")}
              style={this.styles().icon}
            >
              <Ionicons
                name="add-circle-outline"
                size={this.context.sizes.itemHeight}
                color={this.context.colors.foreground}
              />
            </TouchableOpacity>
          </HoverableTooltip>
        </View>

        {this.renderVisNetwork()}

        <View />
      </View>
    );
  }

  // Calculate total descendants for a value
  calculateDescendantCount = (value, valueMap, visited = new Set()) => {
    if (!value || !value.child_ids || value.child_ids.length === 0) {
      return 0;
    }

    // Prevent cycles
    if (visited.has(value.id)) {
      return 0;
    }
    visited.add(value.id);

    let count = value.child_ids.length; // Direct children

    // Recursively count descendants
    value.child_ids.forEach(childId => {
      let child = valueMap.get(childId);
      if (child) {
        count += this.calculateDescendantCount(child, valueMap, new Set(visited));
      }
    });

    return count;
  };

  // Helper to create a node from a value
  createNodeForValue = (value, shape, sizeByDescendants = false, valueMap = null) => {
    let color = valueHelpers.getColor(value, this.context.colorScheme);
    let background = colorHelpers.modifyHex(color, 0.6);
    let border = color;
    let icon = valueHelpers.getIcon(value);

    let valueText = valueHelpers.filterRichText(
      value.title || value.text || '',
      value,
    );

    // Calculate size metric
    let sizeMetric = value.level || 1;
    if (sizeByDescendants && valueMap) {
      let descendantCount = this.calculateDescendantCount(value, valueMap);
      // Scale descendant count to a reasonable range (similar to levels)
      // Most values have 1-20 descendants, we want this to map to roughly 1-10 range
      sizeMetric = Math.min(Math.max(1, Math.floor(descendantCount / 2)), 15);
    }

    return {
      id: value.id,
      title: valueText,
      label: shape == "icon" ? valueText : iconHelpers.unicode(icon),
      font: {
        color,
        face: iconHelpers.fontFamily(icon),
      },
      icon: {
        code: iconHelpers.unicode(icon),
        weight: "bold",
        color,
        face: iconHelpers.fontFamily(icon),
        size: 40 + sizeMetric * 15,
      },
      color: {
        background,
        border,
        hover: {
          background,
          border,
        },
        highlight: {
          border: background,
        },
      },
      value: (sizeMetric + 1) * 4,
    };
  };

  // Build tree without duplicates - each value appears once, connected to all its parents
  buildTreeWithoutDuplicates = (centralNodeId, valueMap, values, nodes, edges, shape, sizeByDescendants) => {
    // Create a set of all value IDs in our filtered values
    let valueIds = new Set(values.map(v => v.id));

    // Track which values have been added as nodes
    let addedNodes = new Set();

    // Add all values as nodes (except central node if it's a value)
    values.forEach(value => {
      // Skip if this is the central node
      if (value.id === centralNodeId) return;

      let node = this.createNodeForValue(value, shape, sizeByDescendants, valueMap);
      nodes.push(node);
      addedNodes.add(value.id);
    });

    // Create edges from parents to children
    values.forEach(value => {
      // Skip if this is the central node
      if (value.id === centralNodeId) return;

      let color = valueHelpers.getColor(value, this.context.colorScheme);

      // Check if this value should connect directly to root
      let shouldConnectToRoot = false;

      if (!value.parent_ids || value.parent_ids.length === 0) {
        // No parents at all - connect to root
        shouldConnectToRoot = true;
      } else if (centralNodeId !== "root" && value.parent_ids.includes(centralNodeId)) {
        // Custom root is a parent - connect to root
        shouldConnectToRoot = true;
      } else if (centralNodeId === "root") {
        // Using default "root" - check if any parents are in our filtered value set
        let hasParentInSet = value.parent_ids.some(pid => valueIds.has(pid));
        if (!hasParentInSet) {
          // No parents in our filtered set - connect to root
          shouldConnectToRoot = true;
        }
      }

      if (shouldConnectToRoot) {
        // Variable spring length based on level
        let valueLevel = value.level || 1;
        let springLength = 300 - (valueLevel * 15);
        springLength = Math.max(springLength, 100);

        edges.push({
          from: centralNodeId,
          to: value.id,
          color: color,
          length: springLength,
        });
      }

      // Create edges from this value to all its children (parent -> child direction)
      if (value.child_ids && Array.isArray(value.child_ids)) {
        value.child_ids.forEach(childId => {
          // Only create edge if child is in our node set
          if (addedNodes.has(childId)) {
            // Get child to determine spring length
            let childValue = valueMap.get(childId);
            let childLevel = childValue?.level || 1;
            let springLength = 300 - (childLevel * 15);
            springLength = Math.max(springLength, 100);

            edges.push({
              from: value.id,
              to: childId,
              color: color,
              length: springLength,
            });
          }
        });
      }
    });
  };

  // Build tree with duplicates - values can appear multiple times in different branches
  buildTreeWithDuplicates = (parentNodeId, valueMap, nodes, edges, visitedInPath, pathPrefix, shape, sizeByDescendants, depth = 0) => {
    console.log(`buildTreeWithDuplicates called: parentNodeId=${parentNodeId}, depth=${depth}, pathPrefix="${pathPrefix}"`);

    // Safety: prevent infinite recursion
    if (depth > 50) {
      console.warn("Max depth reached in buildTreeWithDuplicates");
      return;
    }

    // Get the parent value (null if this is the default root)
    let parentValue = null;
    let isDefaultRoot = parentNodeId === "root";

    // Find children of this parent
    let children = [];

    if (isDefaultRoot) {
      // This is default "root" - find all values with no parents OR whose parents are not in valueMap
      children = Array.from(valueMap.values()).filter(v => {
        if (!v.parent_ids || v.parent_ids.length === 0) {
          return true; // No parents at all
        }
        // Check if any parents exist in our valueMap
        let hasParentInMap = v.parent_ids.some(pid => valueMap.has(pid));
        return !hasParentInMap; // Include if no parents in our filtered set
      });
      console.log(`Default root has ${children.length} top-level children (${Array.from(valueMap.values()).filter(v => !v.parent_ids || v.parent_ids.length === 0).length} with no parents, ${children.length - Array.from(valueMap.values()).filter(v => !v.parent_ids || v.parent_ids.length === 0).length} with parents outside set)`);
    } else {
      // Try to get the parent value from the map
      parentValue = valueMap.get(parentNodeId);

      if (parentValue && parentValue.child_ids && Array.isArray(parentValue.child_ids)) {
        // Parent found in map - use its child_ids
        children = parentValue.child_ids
          .map(cid => valueMap.get(cid))
          .filter(c => c != null);
        console.log(`Parent ${parentNodeId} (found in map, trying child_ids) has ${children.length} children`);
      }

      // If we didn't find any children via child_ids, try searching by parent_ids
      // This handles when children were filtered out or parent has no child_ids
      if (children.length === 0) {
        children = Array.from(valueMap.values()).filter(v => {
          return v.parent_ids && v.parent_ids.includes(parentNodeId);
        });
        console.log(`Parent ${parentNodeId} (searched by parent_ids) has ${children.length} children`);
      }
    }

    if (children.length === 0) {
      console.log(`No children found for parent ${parentNodeId}, returning`);
      return;
    }

    children.forEach((child, index) => {
      // Create unique ID for this instance of the child
      // For first level (no pathPrefix), just use child.id
      // For deeper levels, append to path: "parent1_parent2_childId"
      let uniqueId = pathPrefix ? `${pathPrefix}_${child.id}` : `${child.id}`;

      // Check for cycles in current path
      if (visitedInPath.has(child.id)) {
        console.warn(`Cycle detected: ${child.id} already in path`);
        return;
      }

      // Create node for this child
      let node = this.createNodeForValue(child, shape, sizeByDescendants, valueMap);
      node.id = uniqueId; // Override with unique ID
      nodes.push(node);

      // Create edge from parent to this child
      let color = valueHelpers.getColor(child, this.context.colorScheme);

      // Determine the 'from' node ID
      let fromNodeId = parentNodeId;
      if (pathPrefix && parentNodeId !== "root") {
        // If we have a pathPrefix and not at root, use it as the from ID
        fromNodeId = pathPrefix;
      }

      // Variable spring length based on level
      // Lower level (fewer children) = longer spring for more spread
      // Higher level (more children) = shorter spring to stay near center
      let childLevel = child.level || 1;
      let springLength = 300 - (childLevel * 15); // level 1 = 285, level 10 = 150
      springLength = Math.max(springLength, 100); // minimum 100

      edges.push({
        from: fromNodeId,
        to: uniqueId,
        color: color,
        length: springLength,
      });

      // Recursively add this child's children
      let newVisited = new Set(visitedInPath);
      newVisited.add(child.id);
      this.buildTreeWithDuplicates(
        child.id,
        valueMap,
        nodes,
        edges,
        newVisited,
        uniqueId,
        shape,
        sizeByDescendants,
        depth + 1
      );
    });
  };

  renderVisNetwork = () => {
    let shape = "circle";
    // shape = 'icon'

    let { values, rootId, rootValue, showDuplicates, sizeByDescendants, physicsEnabled, hierarchicalLayout } = this.state;

    // Ensure values is an array
    if (!values || !Array.isArray(values)) {
      values = [];
    }

    console.log(`Before applyFilters: ${values.length} values`);
    values = this.applyFilters(values);
    console.log(`After applyFilters: ${values.length} values`);

    // Determine if we should show a central root node
    let showCentralNode = true;
    let centralNodeId = rootId !== "root" && rootValue ? rootValue.id : "root";
    let centralNodeTitle = "Root";
    let centralNodeLabel = " ";

    // If we have a custom root value, use its details
    if (rootId !== "root" && rootValue) {
      centralNodeTitle = valueHelpers.filterRichText(
        rootValue.title || rootValue.text || '',
        rootValue,
      );
      let icon = valueHelpers.getIcon(rootValue);
      centralNodeLabel = iconHelpers.unicode(icon);
    }

    // Create central node
    let centralNode = {
      id: centralNodeId,
      x: 0,
      y: 0,
      fixed: { x: true, y: true },
      value: 100,
      title: centralNodeTitle,
      label: centralNodeLabel,
      color: {
        background: this.context.colors.empty,
        border: this.context.colors.fill,
        hover: {
          background: this.context.colors.empty,
          border: this.context.colors.trim,
        },
        highlight: {
          background: this.context.colors.empty,
          border: this.context.colors.active,
        },
      },
    };

    let nodes = [];
    let edges = [];

    if (showCentralNode) nodes = [centralNode];

    // Build a lookup map for values
    let valueMap = new Map();
    values.forEach(v => valueMap.set(v.id, v));

    // If we have a custom root value, make sure it's in the map
    if (rootValue && !valueMap.has(rootValue.id)) {
      valueMap.set(rootValue.id, rootValue);
    }

    console.log(`Building network: centralNodeId=${centralNodeId}, showDuplicates=${showDuplicates}, values=${values.length}`);
    console.log(`Root value:`, rootValue);
    console.log(`ValueMap size: ${valueMap.size}`);

    if (showDuplicates) {
      console.log("=== BUILDING WITH DUPLICATES ===");
      // When duplicates are shown, traverse tree and create duplicate nodes
      this.buildTreeWithDuplicates(
        centralNodeId,
        valueMap,
        nodes,
        edges,
        new Set(),
        "",
        shape,
        sizeByDescendants
      );
      console.log(`After buildTreeWithDuplicates: ${nodes.length} nodes, ${edges.length} edges`);
    } else {
      // When duplicates are hidden, create one node per value
      this.buildTreeWithoutDuplicates(
        centralNodeId,
        valueMap,
        values,
        nodes,
        edges,
        shape,
        sizeByDescendants
      );
    }

    // Log for debugging
    console.log(`Rendered ${nodes.length} nodes and ${edges.length} edges`);

    // console.warn(nodes.length)

    const graph = { nodes, edges };

    console.log(`Rendering mode: hierarchical=${hierarchicalLayout}, physics=${physicsEnabled && !hierarchicalLayout}`);

    const options = {
      layout: {
        hierarchical: hierarchicalLayout ? {
          enabled: true,
          direction: 'UD', // Up-Down: root at top, children below
          sortMethod: 'directed', // Respects edge direction
          nodeSpacing: 150, // Horizontal space between nodes
          levelSeparation: 200, // Vertical space between levels
          treeSpacing: 250, // Space between separate trees
        } : false,
        // clusterThreshold: 50,
      },
      physics: {
        enabled: physicsEnabled && !hierarchicalLayout, // Disable physics for hierarchical layout
        minVelocity: 0.75, // Stop when velocity drops below this (lower = smoother stop)
        maxVelocity: 50, // Cap velocity for smoother motion
        solver: 'barnesHut',
        timestep: 0.5, // Larger timestep for smoother, more fluid motion
        adaptiveTimestep: true, // Automatically adjust for performance
        stabilization: {
          enabled: true,
          iterations: hierarchicalLayout ? 0 : (physicsEnabled ? 100 : 0), // Reduced from 500
          fit: true,
          updateInterval: 25, // Update every 25 iterations for smoother progress
        },
        // repulsion: {
        //   // springConstant: 0.1, // default 0.05
        //   springConstant: 0.01, // default 0.05
        //   // nodeDistance: 100,
        //   centralGravity: 0, // default 0.2
        //   springLength: 15, // default 200
        // },
        barnesHut: {
          theta: 0.5,
          gravitationalConstant: -30000, // Stronger repulsion - more negative = more space between nodes
          centralGravity: 0.1, // Reduced from 0.3 - less pull to center allows more spread
          springLength: 200, // Increased from default 95 - longer springs = more space
          springConstant: 0.08, // Increased from 0.01 - stronger springs for better dragging behavior
          damping: 0.09, // Reduced from 0.15 - less damping = more fluid, less jittery
          avoidOverlap: 0.8, // Increased from 0.5 - better overlap avoidance
        },
      },
      edges: {
        color: "#000000",
        smooth: {
          enabled: true, // Always enable smooth for better visual feedback
          type: hierarchicalLayout ? 'cubicBezier' : 'dynamic',
          roundness: 0.5,
        },
        // dashes: true,
        // arrows: false,
        arrows: {
          to: {
            enabled: false,
          },
          //   middle: {
          //     enabled: true,
          //     // imageHeight: 32,
          //     // imageWidth: 32,
          //     scaleFactor: 1,
          //     // src: "https://visjs.org/images/visjs_logo.png",
          //     // type: "image"
          //     type: 'arrow',
          //   },
          from: {
            enabled: false,
          },
        },
      },
      nodes: {
        shape,
        value: 1,
        scaling: {
          min: 10,
          max: 20,
          label: {
            enabled: true,
            min: 5,
            max: 10,
            maxVisible: 20,
            drawThreshold: 5,
          },
          // customScalingFunction: function (min,max,total,value) {
          //   return value
          // },
          customScalingFunction: function (min, max, total, value) {
            if (shape == "circle") {
              return value;
            }
            if (max === min) {
              return 0.5;
            } else {
              let scale = 1 / (max - min);
              return Math.max(0, (value - min) * scale);
              // return Math.max(0,value*scale);
            }
          },
        },
        borderWidth: 2,
      },
      interaction: {
        hover: true,
        dragNodes: true, // Enable node dragging
        dragView: true, // Enable canvas panning
        zoomView: true, // Enable zooming
        keyboard: {
          enabled: true,
        },
        navigationButtons: false,
        tooltipDelay: 200,
      },
      height: "1100px",
    };

    const events = {
      select: (event) => {
        var { nodes, edges } = event;
        if (nodes && nodes.length > 0) {
          let selectedNodeId = nodes[0];

          // Extract actual value ID from unique ID (in case of duplicates)
          // Unique IDs are in format: "valueId" or "parentPath_valueId"
          let actualValueId = selectedNodeId;
          if (typeof selectedNodeId === 'string' && selectedNodeId.includes('_')) {
            let parts = selectedNodeId.split('_');
            actualValueId = parseInt(parts[parts.length - 1]);
          }

          // Navigate to the value (skip if it's the root node)
          if (actualValueId !== "root" && actualValueId !== centralNodeId) {
            this.props.navigation.navigate("Project", { id: actualValueId });
          }
        }
      },
    };
    return (
      <Graph
        graph={graph}
        options={options}
        events={events}
        getNetwork={(network) => {
          //  if you want access to vis.js network api you can set the state in a parent component using this property
        }}
      />
    );
  };

  applyFilters = (values, affectLeveling = true) => {
    // Early return if no values
    if (!values || !Array.isArray(values)) {
      console.log("applyFilters: no values or not an array");
      return [];
    }

    console.log(`applyFilters starting with ${values.length} values`);

    let {
      hideComplete,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      showHidden,
      showSnoozed,
      query,
      hiddenIds,
    } = this.state;

    // Filter completed values
    if (hideComplete) {
      let beforeLength = values.length;
      values = values.filter((v) => !v.completed_at);
      console.log(`After hideComplete filter: ${beforeLength} -> ${values.length}`);
    }

    // Filter snoozed values
    if (showSnoozed == 0) {
      // Hide snoozed
      values = values.filter((v) => !valueHelpers.isSnoozed(v));
    } else if (showSnoozed == 2) {
      // Show only snoozed
      values = values.filter((v) => valueHelpers.isSnoozed(v));
    }
    // showSnoozed == 1 means show all (no filter)

    // Filter starred (placeholder for future implementation)
    if (showOnlyStarred) {
      // values = values.filter(v => v.starred)
    }

    // Filter notes (skip complex timeline/milestone logic if data not available)
    if (!showNotes) {
      values = values.filter((v) => {
        // Only filter if we have child_ids
        if (!v.child_ids || v.child_ids.length > 0) return true;

        // Skip complex timeline filtering if timeline data not available
        if (!v.timeline || !v.milestones) return true;

        // Notes cannot have children
        if (
          v.timeline.length == 2 &&
          v.milestones[0]?.indexOf("note from") == 0
        ) {
          return false;
        } else if (
          v.timeline.length == 1 &&
          !timeHelpers.wasToday(v.timeline[0]?.timestamp)
        ) {
          return false;
        }

        return true;
      });
    }

    // Filter done today
    if (showDoneToday == 0 && !affectLeveling) {
      values = values.filter((v) => !textHelpers.wasDoneToday(v, true));
    }

    if (showDoneToday == 2) {
      // Get all items done today
      let doneToday = values.filter((v) => textHelpers.wasDoneToday(v, true));
      let doneTodaySet = new Set(doneToday.map(v => v.id));

      // Get all parent IDs
      let parentIds = doneToday.flatMap((val) => val.parent_ids || []);

      // Efficiently traverse up the tree (with max depth protection)
      let maxDepth = 100;
      let depth = 0;

      while (parentIds.length && depth < maxDepth) {
        depth++;

        // Find new parents not already in doneToday
        let newParents = values.filter(
          (v) => parentIds.includes(v.id) && !doneTodaySet.has(v.id)
        );

        if (newParents.length === 0) break;

        // Add to result set
        newParents.forEach(p => {
          doneToday.push(p);
          doneTodaySet.add(p.id);
        });

        // Get next level of parents
        parentIds = newParents.flatMap((val) => val.parent_ids || []);
      }

      values = doneToday;
    }

    // Filter hidden values
    hiddenIds = hiddenIds || [];

    if (showHidden == 0 || showHidden == 2) {
      let shouldRemove = showHidden == 2;
      let hiddenSet = new Set(hiddenIds);

      values = values.filter((v) => {
        if (hiddenSet.has(v.id)) {
          return shouldRemove;
        } else if (v.parent_ids && v.parent_ids.length == 1) {
          if (hiddenSet.has(v.parent_ids[0])) {
            // Mark as hidden if only parent is hidden
            hiddenSet.add(v.id);
            return shouldRemove;
          } else {
            return !shouldRemove;
          }
        }
        return !shouldRemove;
      });
    }

    // Filter by query text
    if (query && query.length > 0) {
      let beforeLength = values.length;
      const lowerQuery = query.toLowerCase();
      values = values.filter((v) => {
        // Safely check text
        const text = v.text || v.title || '';
        if (text.toLowerCase().indexOf(lowerQuery) >= 0) return true;

        // Check revisions if they exist
        if (v.revisions && Array.isArray(v.revisions)) {
          return v.revisions.some((r) => {
            const revText = r.text || '';
            return revText.toLowerCase().indexOf(lowerQuery) >= 0;
          });
        }

        return false;
      });
      console.log(`After query filter: ${beforeLength} -> ${values.length}`);
    }

    console.log(`applyFilters returning ${values.length} values`);
    return values;
  };

  determineLevels = (values) => {
    let { fromBottom } = this.state;
    let highestLevel = 0;
    values.map((v) => {
      // if(v.id == 20) console.log(v)
      if (v.level > highestLevel) {
        highestLevel = v.level;
      }
    });
    // console.warn(highestLevel)
    let levels = new Array(highestLevel + 1).fill(0).map((x, i) => i);
    if (fromBottom) levels = levels.reverse();
    if (REVERSE) levels = levels.reverse();
    return levels;
  };

  handleClickValue = (value) => {
    let { values } = this.state;
    value.clicked = true;
    values.map((v) => (v.id == value.id ? value : v));
    this.setState({ values });
  };

  constelate = (value, upwards = true) => {
    let lines = [];
    if (!!!this[`val_${value.id}`]) return lines;
    // console.log(this[`val_${value.id}`].state.absX, this[`val_${value.id}`].state.absY)
    let origin = [
      this[`val_${value.id}`].state.absX,
      this[`val_${value.id}`].state.absY,
      // this[`val_${value.id}`].state.absX ,
      // this[`val_${value.id}`].state.absY,
      value.id,
    ];

    let targetIds = upwards ? value.parent_ids : value.child_ids;
    // console.log(value, upwards, targetIds)
    // return []
    let targetXs = [];
    targetIds.forEach((id) => {
      if (!!this[`val_${id}`]) {
        let pointX = this[`val_${id}`].state.absX;
        if (targetXs.includes(pointX)) pointX += 10;
        targetXs.push(pointX);
        let pointY = this[`val_${id}`].state.absY;
        let point = [pointX, pointY, id];
        lines.push([origin, point]);
      }
    });
    return lines;
  };

  hoverIn = async (value) => {
    this.setState({ pendingSelectedValue: value });
    await new Promise((resolve) => setTimeout(resolve, 700));
    if (this.state.pendingSelectedValue?.id != value.id) return;
    // console.log(value)
    let { values } = this.state;
    let familyIds = [value.id];
    let lines = [];

    if (CONSTELATE) lines = [...lines, ...this.constelate(value, true)];

    // let familyIds = textHelpers.getFamilyIds(value)

    let parentIds = value.parent_ids;
    while (parentIds.length) {
      familyIds = [...familyIds, ...parentIds];
      let parents = values.filter((v) => parentIds.includes(v.id));
      parentIds = parents.map((v) => v.parent_ids).flat();
      if (CONSTELATE)
        parents.forEach(
          (val) => (lines = [...lines, ...this.constelate(val, true)]),
        );
    }

    if (CONSTELATE) lines = [...lines, ...this.constelate(value, false)];

    let childIds = value.child_ids;
    while (childIds.length) {
      familyIds = [...familyIds, ...childIds];
      let children = values.filter((v) => childIds.includes(v.id));
      childIds = children.map((v) => v.child_ids).flat();
      if (CONSTELATE)
        children.forEach(
          (val) => (lines = [...lines, ...this.constelate(val, false)]),
        );
    }

    familyIds = [...new Set(familyIds)];
    this.setState({ familyIds, lines, selectedValue: value });
  };

  hoverOut = (value = null) => {
    this.setState({
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
    });
  };

  handleKeyPress = (event) => {
    // console.log('keypress:', event.keyCode, event.keyValue)
    let triggerKey = false;
    // 13 == enter
    // 9 == tab
    if (event.keyCode == 9) {
      return;
      event.preventDefault();
      console.log("tab");
      if (this.state.shiftIsDown) {
        console.log("unindent!");
        // this.handleUnindentItem(item)
      } else {
        // this.handleIndentItem(item)
      }
    } else if (event.keyCode == 13) {
      event.preventDefault();
      console.log("enter");
      // this.handleAppendItem(item)
    } else if (event.keyCode == 8) {
      console.log("backspace");
      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (event.keyCode == 16) {
      console.log("shift down");
      this.setState({ shiftIsDown: true });
      triggerKey = true;
    } else if (event.keyCode == 27) {
      console.log("escape");
      this.setState({ query: "" });
    }
    // 38 // up
    // 39 // right
    // 40 // down
    // 37 // left
    if (!triggerKey) {
      this.setState({ shiftIsDown: false });
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-around",
      // backgroundColor: '#111',
    },
    row: {
      flexGrow: 1,
      borderColor: this.context.colors.trim,
      // borderBottomWidth: 1,
      alignSelf: "stretch",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: this.context.sizes.large,
    },
    queryRow: {
      flexGrow: 0,
      height: 50,
      padding: this.context.sizes.base,
      marginTop: 60, // Push down to avoid navbar overlap
      justifyContent: "flex-start",
    },
    input: {
      ...styleSheet.input,
      alignSelf: "stretch",
      flex: 1,
    },
    icon: {
      marginLeft: this.context.sizes.base,
      minWidth: this.context.sizes.base,
      minHeight: this.context.sizes.base,
      // borderWidth: 1, borderColor: 'white',
    },
  });
}
